var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockRewind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_4383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2783 11.8763C21.2783 17.0689 17.0689 21.2784 11.8763 21.2784C6.68366 21.2784 2.47421 17.0689 2.47421 11.8763C2.47421 6.68369 6.68366 2.47424 11.8763 2.47424C12.5889 2.47424 13.283 2.55352 13.9503 2.70375",
    stroke: "#FABF35",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4595 7.23025V11.5122C11.4595 12.0074 11.6451 12.4846 11.9798 12.8497L14.5467 15.65M19.299 10.8865L20.4036 9.78187C20.8867 9.29876 21.67 9.29876 22.1532 9.78187L23.2578 10.8865M11.8763 2.47412C14.9855 2.47412 17.7423 3.98335 19.4538 6.30917",
    stroke: "#FABF35",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_4383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.7526,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRewind);
export default __webpack_public_path__ + "static/media/clock-rewind.6806c792a14c83ff2c897778ef900e66.svg";
export { ForwardRef as ReactComponent };